import {
    ACTION_SET_TEMPLATES,
    ACTION_SET_CONTRACTS,
    ACTION_UNSET_CONTRACTS,
    ACTION_CREATE_CONTRACT,
    ACTION_UPDATE_CONTRACT,
} from '../actions/contract';

const initialState = {
    templates: [],
    items: [],
};

export default function contract(state = initialState, { type, payload }) {
    const updateContract = () => {
        return state.items.map((contract) =>
            contract._id === payload._id ? payload : contract
        );
    };
    switch (type) {
        case ACTION_SET_TEMPLATES:
            return { ...state, templates: payload };
        case ACTION_SET_CONTRACTS:
            return { ...state, items: payload };
        case ACTION_UNSET_CONTRACTS:
            return { ...state, items: [] };
        case ACTION_CREATE_CONTRACT:
            return { ...state, items: [...state.items, payload] };
        case ACTION_UPDATE_CONTRACT:
            return { ...state, items: updateContract(payload) };
        default:
            return state;
    }
}
